// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-component {
  z-index: 10;
}

.main-modal {
  padding-top: 5%;
}

.main-modal .modal-content {
  background-color: #1F222A;
}

.modal-title {
  color: #fff;
  font-weight: 600;
  letter-spacing: -1px;
}

.modal-header {
  border-bottom-color: #35383F;
}

.modal-body {
  color: #fff;
  padding-top: 50px;
}

.modal-body p b {
  margin-left: 5px;
}

.modal-footer {
  border-top-color: #35383F;
}

.modal-footer button {
  font-weight: 600;
  border-radius: 10px;
  font-size: 14px;
}

.link-stripe-btn {
  width: 300px;
  margin: 0 auto;
  text-align: center;
}

.link-stripe-btn button {
  background-color: #22BB9C;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  padding: 8px 30px;
  margin-top: 30px;
  color: #fff;
  font-weight: 700;
}

.stripe-logo {
  text-align: center;
}

.stripe-logo img {
  width: 200px;
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/Components/Styles/modal-component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AACA;EACE,WAAA;EACA,gBAAA;EACA,oBAAA;AAEF;;AAAA;EACE,4BAAA;AAGF;;AADA;EACE,WAAA;EACA,iBAAA;AAIF;;AADA;EACE,gBAAA;AAIF;;AADA;EACE,yBAAA;AAIF;;AAFA;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;AAKF;;AAFA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;AAKF;;AAHA;EACE,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAMF;;AAJA;EACE,kBAAA;AAOF;;AALA;EACE,YAAA;EACA,cAAA;AAQF","sourcesContent":[".modal-component {\n  z-index: 10;\n}\n\n.main-modal{\n  padding-top: 5%;\n}\n\n.main-modal .modal-content{\n  background-color: #1F222A;\n}\n.modal-title{\n  color: #fff;\n  font-weight: 600;\n  letter-spacing: -1px;\n}\n.modal-header{\n  border-bottom-color: #35383F;\n}\n.modal-body{\n  color: #fff;\n  padding-top: 50px;\n}\n\n.modal-body p b{\n  margin-left: 5px;\n}\n\n.modal-footer{\n  border-top-color: #35383F;\n}\n.modal-footer button{\n  font-weight: 600;\n  border-radius: 10px;\n  font-size: 14px;\n}\n\n.link-stripe-btn{\n  width: 300px;\n  margin: 0 auto;\n  text-align: center;\n}\n.link-stripe-btn button{\n  background-color: #22BB9C;\n  border: none;\n  border-radius: 20px;\n  font-size: 14px;\n  padding: 8px 30px;\n  margin-top: 30px;\n  color: #fff;\n  font-weight: 700;\n}\n.stripe-logo {\n  text-align: center;\n}\n.stripe-logo img {\n  width: 200px;\n  margin: 0 auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
